import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { getAchAccountsAsync } from '../../../API/order/escrow/EscrowAPI';
import { IAchAccountData } from '../../../types/accounting/data/IEscrowExpectedIncomingAchData';

export const { slice: getAchAccountsSlice, asyncAction: getAchAccountsAction } = createAsyncSliceWithDataAndQuery(
  'getAchAccountsSlice',
  getAchAccountsAsync,
  [] as IAchAccountData[]
);
